/*
 * This file contains common functions.
 */
var app = {
	// Variable por defecto si no se pasa un selector distinto desde la llamada
	classNotEmptySelector: 'input[type!=hidden][type!=checkbox]:not(.js-search-input)',

	// Función que comprueba si los inputs tienen contenido en cuyo caso se añade la clase necesaria para que el label no se superponga
	addClassIfNotEmptyInput: function (selector) {
		// $('input[type!=hidden][type!=checkbox]:not(.js-search-input)').each(function (index, value) {
		// 		if ($(value).val()) {   
		//			$(value).closest(".form-group").addClass("is-full");
		// 		}
		// });

		if (typeof selector === 'undefined') {
			selector = app.classNotEmptySelector;
		}

		$(selector).each(function (index, value) {
			if ($(value).val()) {
				$(value).closest(".form-group").addClass("is-full");
			}
		});
	}
};

function submitForm(first_action, second_action) {
	console.log('Submit form event 12:44')
	var name = $("#name").val()
	var surname = $("#surname").val()
	var email = $("#email").val()
	var phone = $("#phone").val()
	var type_contact = $("#type_contact").val()
	var country = $("#country").val()
	var title = $("#title").val()
	var type_conocido = $("#type_conocido").val()
	var description = $("#description").val()

	if (name !== '' && surname !== '' && email !== '' && phone !== '' && type_contact !== '' && country !== '' && title !== '' && type_conocido !== '' && description !== '') {
		// $("#form_action").removeAttr("name")

		try {
		
			$("#salesforceID").contents().find("body").append(
				'<form action="https://go.persax.es/l/916781/2021-04-20/2tkq" method="POST" id="virtual_form">' +
				'<input type="hidden" name="name" value="' + name + '">' +
				'<input type="hidden" name="surname" value="' + surname + '">' +
				'<input type="hidden" name="email" value="' + email + '">' +
				'<input type="hidden" name="phone" value="' + phone + '">' +
				'<input type="hidden" name="type_contact" value="' + type_contact + '">' +
				'<input type="hidden" name="country" value="' + country + '">' +
				'<input type="hidden" name="title" value="' + title + '">' +
				'<input type="hidden" name="type_conocido" value="' + type_conocido + '">' +
				'<input type="hidden" name="message" value="' + description + '">' +
				'<input type="submit" name="otraCosa" value="submit" id="enviarPardot">"' +
				'</form>'
			)

			$("#salesforceID")
				.contents()
				.find("body")
				.find("form")
				.submit()

			console.log('He enviado el form de salesforce')
		} catch (error) {
			console.log('El formulario virtual no guay')
		}


		try {
			// $("#form_action").attr("name", "action")
			// document.forms['contact_form'].action = first_action;
			// document.forms['contact_form'].submit()

			$("#contact_form")
			.attr("action", first_action)

			$("#contact_form")
			.submit()
		} catch (error) {
			console.log('El envio de correo a beatriz no guay')
		}

		return false
	}

	return false
}

async function pardotAction(name, surname, email, phone, type_contact, country, title, type_conocido, description) {
	console.log('Hago la llamada')

	/*$(document.body)
	.append('<form action="https://go.persax.es/l/916781/2021-04-20/2tkq" method="POST" id="virtual_form">' + 
				'<input type="hidden" name="name" value="' + name + '">' +
				'<input type="hidden" name="surname" value="' + surname + '">' +
				'<input type="hidden" name="email" value="' + email + '">' +
				'<input type="hidden" name="phone" value="' + phone + '">' +
				'<input type="hidden" name="type_contact" value="' + type_contact + '">' +
				'<input type="hidden" name="country" value="' + country + '">' +
				'<input type="hidden" name="title" value="' + title + '">' +
				'<input type="hidden" name="type_conocido" value="' + type_conocido + '">' +
				'<input type="hidden" name="description" value="' + description + '">' +
			'</form>')
	
	$("#virtual_form").submit()*/


	return true
}